import {
  Component,
  Output,
  EventEmitter,
  Input,
  signal,
  ViewEncapsulation,
  OnInit,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../sidebar/sidebar-data';
import { TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppSettings } from 'src/app/config';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from 'src/app/core/services/auth.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { RegistreService } from 'src/app/core/services/registre.service';
import { PopupAndNotifService } from 'src/app/core/services/popup-and-notif.service';
import { ApscanLoginDialogComponent } from './apscan-login-dialog.component';
import { InappNotificationBellComponent } from 'src/app/core/components/inapp-notification-bell/inapp-notification-bell.component';
import { MicrosoftReconnectComponent } from 'src/app/core/components/microsoft-reconnect/microsoft-reconnect.component';
import { InappNotificationsService } from 'src/app/core/services/inapp-notifications.service';

interface profiledd {
  id: number;
  title: string;
  link: string;
  new?: boolean;
}

interface apps {
  id: number;
  icon: string;
  color: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    InappNotificationBellComponent,
    MicrosoftReconnectComponent,
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  isCollapse: boolean = false; // Initially hidden
  group: any = [];
  apscan_access_token: string = '';

  toggleCollpase() {
    this.isCollapse = !this.isCollapse; // Toggle visibility
  }

  ngOnInit() {
    const currentUser = this.authService.currentUser();
    if (currentUser && currentUser !== null) {
      this.group = currentUser.group;
      this.apscan_access_token = currentUser.apscan_access_token;
      /*if (this.apscan_access_token && this.apscan_access_token !== '') {
        // this.is_aptokenaccess = true;
        // this.authService.is_aptokenaccess = true;
        this.checkapscanlogin(true);
      }*/
    }

    if (this.authService.isLogged()) {
      this.inappNotificationsService.startRealtimeStream();
    }
  }

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];

  @Output() optionsChange = new EventEmitter<AppSettings>();

  // Utiliser directement le signal pour la réactivité
  currentUser = this.authService.currentUser;
  profilePic = this.authService.profilePic;

  @Output() searchOverlayActiveChange = new EventEmitter<boolean>();

  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    public authService: AuthService,
    private router: Router,
    public helperService: HelperService,
    private registreservice: RegistreService,
    private popupAndNotifService: PopupAndNotifService,
    private inappNotificationsService: InappNotificationsService
  ) {
    translate.setDefaultLang('en');
    if (this.authService.isLoggedIn()) {
      this.authService.getProfilePic();
    }
  }

  options = this.settings.getOptions();

  logout() {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/login']);
    });
  }

  openSearchDialog() {
    this.searchOverlayActiveChange.emit(true);
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  profiledd: profiledd[] = [
    {
      id: 1,
      title: 'My Profile',
      link: '/',
    },
    {
      id: 2,
      title: 'My Subscription',
      link: '/',
    },
    {
      id: 3,
      title: 'My Invoice',
      new: true,
      link: '/',
    },
    {
      id: 4,
      title: ' Account Settings',
      link: '/',
    },
    {
      id: 5,
      title: 'Sign Out',
      link: '/authentication/login',
    },
  ];

  apps: apps[] = [
    {
      id: 1,
      icon: 'solar:chat-line-line-duotone',
      color: 'primary',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/',
    },
    {
      id: 2,
      icon: 'solar:checklist-minimalistic-line-duotone',
      color: 'secondary',
      title: 'Todo App',
      subtitle: 'Completed task',
      link: '/',
    },
    {
      id: 3,
      icon: 'solar:bill-list-line-duotone',
      color: 'success',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/',
    },
    {
      id: 4,
      icon: 'solar:calendar-line-duotone',
      color: 'error',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/',
    },
    {
      id: 5,
      icon: 'solar:smartphone-2-line-duotone',
      color: 'warning',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/',
    },
    {
      id: 6,
      icon: 'solar:ticket-line-duotone',
      color: 'primary',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/',
    },
    {
      id: 7,
      icon: 'solar:letter-line-duotone',
      color: 'secondary',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/',
    },
    {
      id: 8,
      icon: 'solar:book-2-line-duotone',
      color: 'warning',
      title: 'Contact List',
      subtitle: 'Create new contact',
      link: '/',
    },
  ];

  // APScan Button
  is_aptokenaccess = this.authService.is_aptokenaccess;
  connect_to_apscan() {
    const dialogRef = this.dialog.open(ApscanLoginDialogComponent, {
      width: '400px',
      data: {
        currentUser: this.currentUser(),
      },
    });

    dialogRef.afterClosed().subscribe((connected) => {
      if (connected) {
        this.authService.is_aptokenaccess = true;
        this.is_aptokenaccess = false;
      }
    });
  }

  logout_to_apscan() {

    this.popupAndNotifService.confirmAction('Confirmation', 'Are you sure you want to logout?', 'Confirm', 'Cancel').subscribe(result => {
      if (result) {
        this.is_aptokenaccess = false;
        this.authService.is_aptokenaccess = false;
        this.popupAndNotifService.showSpinner();
        const user = this.currentUser();
        if (user) {
          this.registreservice
            .apsolution_logout(user.username)
            .subscribe(data => {
              this.popupAndNotifService.hideSpinner();
              if (data['status'] == 'success') {
                //this.checkapscanlogin(true);
                this.helperService.openSnackBar(
                  'You are disconnected from APSCAN',
                  'Close'
                );
              } else {
                this.helperService.openSnackBar(data['message'], 'Close');
              }
            });
        }
      }
    });
  }

  checkapscanlogin(justcheck: boolean = false) {
    const user = this.currentUser();
    if (user) {
      this.registreservice
        .apsolution_getreferenciel(user.username)
        .subscribe(data => {
          if (data['result']['response']['result'] == 'Error') {
            this.is_aptokenaccess = false;
            this.authService.is_aptokenaccess = false;
            if (!justcheck)
              this.helperService.openSnackBar(
                'You are not connected to APSCAN',
                'Close'
              );
            //this.connect_to_apscan();
          } else {
            this.is_aptokenaccess = true;
            this.authService.is_aptokenaccess = true;
          }
        });
    }
  }

  refreshpage() {
    window.location.reload();
  }

  /** Same visibility as APScan (KYC + superadmin). */
  canAccessKycHeaderTools(): boolean {
    return (
      this.group?.includes('superadmin') ||
      this.group?.includes('kyc_bo') ||
      this.group?.includes('ext_kyc_bo') ||
      this.group?.includes('kyc_validator')
    );
  }

  /**
   * Artur header launcher — superadmin only. The Aether Document Collector
   * launcher is NOT gated anymore: the GED view is every operator's workspace,
   * and its admin redirects non-KYC users straight to the GED.
   */
  canAccessSuperAdminProductLaunchers(): boolean {
    return this.authService.isSuperAdmin();
  }

  /** Canonical Artur (Next.js) entry; mirrors sidebar external link behavior. */
  openArturAi(): void {
    if (!this.canAccessSuperAdminProductLaunchers()) {
      return;
    }
    this.openExternalAppRoute('/artur/');
  }

  /** Aether Document Collector — lands on the GED view for every user. */
  openDataroomAdmin(): void {
    this.openExternalAppRoute('/dataroom/admin/ged');
  }

  private openExternalAppRoute(route: string): void {
    if (typeof window === 'undefined') {
      return;
    }
    const isLocal =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';
    if (isLocal) {
      window.location.assign(`http://localhost:8184${route}`);
      return;
    }
    const { origin, search, hash } = window.location;
    window.location.assign(`${origin}${route}${search}${hash}`);
  }
}

@Component({
  selector: 'search-dialog',
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    MatDividerModule,
  ],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
